var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.12,
    height: 24.138,
    viewBox: "0 0 21.12 24.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-day",
    "data-name": "Icon awesome-calendar-day",
    d: "M0,21.875a2.263,2.263,0,0,0,2.263,2.263H18.858a2.263,2.263,0,0,0,2.263-2.263V9.052H0Zm3.017-9.052a.757.757,0,0,1,.754-.754H8.3a.757.757,0,0,1,.754.754v4.526A.757.757,0,0,1,8.3,18.1H3.772a.757.757,0,0,1-.754-.754Zm15.84-9.806H16.595V.754A.757.757,0,0,0,15.84,0H14.332a.757.757,0,0,0-.754.754V3.017H7.543V.754A.757.757,0,0,0,6.789,0H5.28a.757.757,0,0,0-.754.754V3.017H2.263A2.263,2.263,0,0,0,0,5.28V7.543H21.12V5.28A2.263,2.263,0,0,0,18.858,3.017Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/calendar-day.e8f102717f20d86a3fe7d31bd2ebae1d.svg";
export { ForwardRef as ReactComponent };